// src/store/slices/authSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RECON } from "../../services/apiConstant";
import apiService from "../../services/apiService";

const initialState = {
  token: localStorage.getItem("authToken") || null,
  user: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem("authToken", action.payload);
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      localStorage.removeItem("authToken");
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const setAuthToken = createAsyncThunk(
  "auth/setAuthToken",
  async (token, { dispatch }) => {
    // Optional: Do something async here if needed
    dispatch(setToken(token));
    return token; // return if needed by extraReducers
  }
);

export const onLogout = createAsyncThunk(
  "auth/setAuthToken",
  async (token, { dispatch }) => {
    // Optional: Do something async here if needed
    dispatch(logout());
    return token; // return if needed by extraReducers
  }
);

export const validateEmail = createAsyncThunk("posts/fetch", async (email) => {
  try {
    const response = await apiService.get(`${RECON.validateEmail}/${email}`);
    return response;
  } catch (error) {
    console.error("❌ Inventory fetch error:", error);
    // return rejectWithValue(error.response?.data || error.message);
  }
});

export const generate = createAsyncThunk(
  "posts/fetch",
  async (email) => {
    try {
      const response = await apiService.post(
        `${RECON.generate}?email=${email}`
      );
      return response;
    } catch (error) {
      console.error("❌ Inventory fetch error:", error);
      // return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const tokenValidate = createAsyncThunk(
  "auth/tokenValidate",
  async (data) => {
    try {
      const response = await apiService.post(`${RECON.tokenValidate}`, data);
      return response;
    } catch (error) {
      console.error("❌ Token validation error:", error);
      // return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchUserInfo = createAsyncThunk(
  "auth/fetchUserInfo",
  async (data, { dispatch }) => {
    try {
      const response = await apiService.post(`${RECON.userInfo}`, data);
      if (response.is_valid && response.email) {
        dispatch(
          setUser({
            email: response.email,
            expires_at: response.expires_at,
          })
        );
        return response;
      }
      return response;
    } catch (error) {
      console.error("❌ User info fetch error:", error);
      // return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const { setToken, logout, setUser } = authSlice.actions;
export default authSlice.reducer;
